import { StylesConfig } from '@atlaskit/select';

import { Colors } from '@/assets';

export const customStylesSelectInput: StylesConfig = {
    container(styles) {
        return {
            ...styles,
            width: '100%',
            border: '1px solid',
            borderColor: Colors.linkWater,
            background: Colors.white,
            borderRadius: '8px',
            boxShadow: '0px 1px 2px rgb(16 24 40 / 5%)',
            fontSize: 16,
            height: 46,
            '> div': {
                backgroundColor: Colors.white,
                paddingLeft: 5,
                border: 0,
                borderRadius: '8px',
                marginTop: 2,
                '&:hover': {
                    backgroundColor: Colors.white
                }
            }
        };
    }
};
